import React from 'react';
import Wahanda from 'common/wahanda';
import ItemRowView from '../summary-view/item-row';
import ItemRowGroupView from '../summary-view/item-group-row';

const lang = Wahanda.lang.reports.transactions.daySummary.cashSummary;

type CashSummary = {
  startOfDay?: number;
  cashSales?: number;
  cashRefunds?: number;
  deposits?: number;
  withdrawals?: number;
  drawerCorrection?: number;
  total?: number;
};

type CashRegisterProps = {
  cashSummary?: CashSummary;
};

const EMPTY_CASH_SUMMARY: Required<CashSummary> = {
  startOfDay: 0,
  cashSales: 0,
  cashRefunds: 0,
  deposits: 0,
  withdrawals: 0,
  drawerCorrection: 0,
  total: 0,
};

export const CashRegister: React.FC<CashRegisterProps> = ({ cashSummary }) => {
  const summary = cashSummary || EMPTY_CASH_SUMMARY;
  return (
    <div className="cash-summary">
      <div className="item important">{lang.heading}</div>
      <div className="item-container">
        <div className="item-group">
          <ItemRowView title={lang.startOfDay} amount={summary.startOfDay ?? 0} />
        </div>
        <ItemRowGroupView
          title={lang.cashSales}
          totalAmount={summary.cashSales}
          refundAmount={summary.cashRefunds}
        />
        <div className="item-group">
          <ItemRowView title={lang.deposits} amount={summary.deposits ?? 0} />
        </div>
        <div className="item-group">
          <ItemRowView title={lang.withdrawals} amount={summary.withdrawals ?? 0} />
        </div>
        {summary.drawerCorrection ? (
          <div className="item-group">
            <ItemRowView title={lang.drawerCorrection} amount={summary.drawerCorrection} />
          </div>
        ) : null}
        <div className="item-group">
          <ItemRowView title={lang.total} amount={summary.total ?? 0} additionalClass="total" />
        </div>
      </div>
    </div>
  );
};
